import React from 'react';
import { useStateValue } from '../../Contexto/store';
import BarSesion from './Bar/BarSesion';

const AppNavbar = () => {
    // se accede a la variable de sesion de usuario
    const [{ sesionUsuario }] = useStateValue();

    // se condiciona el pintado de la barra de sesion en funcion de si 
    //1) El usuario esta en sesion
    //2) Si el usuario esta autenticado 

    return sesionUsuario ?
        (sesionUsuario.autenticado === true ?
            <BarSesion />
            : null
        )
        : null;
};

export default AppNavbar;